'use client';

import { createStore } from 'zustand';

import { CartItem } from '@/types/cart.types';

export type GuidanceAcceptanceState = {
  acceptedSignature: string | null;
};

const initialState: GuidanceAcceptanceState = {
  acceptedSignature: null,
};

export const guidanceAcceptanceStore = createStore<GuidanceAcceptanceState>(() => ({ ...initialState }));

export function buildCartSignature(items: CartItem[]): string {
  return items.map((item) => item.id).sort().join('|');
}

export const acceptGuidance = (signature: string) => {
  guidanceAcceptanceStore.setState({ acceptedSignature: signature });
};

export const revokeGuidance = () => {
  guidanceAcceptanceStore.setState({ acceptedSignature: null });
};

export const resetGuidanceAcceptance = () => {
  guidanceAcceptanceStore.setState({ ...initialState });
};
